module.exports = __webpack_public_path__ + "static/img/logo_white.620ebc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_white.png
// module id = 1SqM
// module chunks = 1